import styled from 'styled-components';
import {
  FaBed,
  FaHome,
  FaCouch,
  FaDoorOpen,
  FaWindowMaximize,
  FaTable,
  FaChair,
  FaLightbulb,
  FaImage,
  FaDoorClosed,
  FaArchive,
  FaCamera,
} from 'react-icons/fa';
import { BiArchive } from "react-icons/bi";
import { MdOutlineImage } from 'react-icons/md';
import { IconType } from 'react-icons';
import DoorOpenIcon from '../../icons/DoorOpenIcon.svg?react';
import ArchiveIcon from '../../icons/ArchiveIcon.svg?react';

interface CategoryItemProps {
  category: string;
  selected: boolean;
  onClick: () => void;
  icon?: IconType;
}

/**
 * Maps category names to appropriate icons
 */
export const getCategoryIcon = (category: string): IconType => {
  const lowerCategory = category.toLowerCase();
  
  // Map common category names to icons
  if (lowerCategory.includes('bed') || lowerCategory.includes('lit')) {
    return FaBed;
  }
  if (lowerCategory.includes('floor') || lowerCategory.includes('sol')) {
    return FaHome;
  }
  if (lowerCategory.includes('wall') || lowerCategory.includes('mur')) {
    return FaImage;
  }
  if (lowerCategory.includes('mirror') || lowerCategory.includes('miroir')) {
    return MdOutlineImage;
  }
  if (lowerCategory.includes('door') || lowerCategory.includes('porte')) {
    return FaDoorOpen;
  }
  if (lowerCategory.includes('window') || lowerCategory.includes('fenêtre')) {
    return FaWindowMaximize;
  }
  if (lowerCategory.includes('table')) {
    return FaTable;
  }
  if (lowerCategory.includes('chair') || lowerCategory.includes('chaise')) {
    return FaChair;
  }
  if (lowerCategory.includes('light') || lowerCategory.includes('lumière')) {
    return FaLightbulb;
  }
  if (lowerCategory.includes('couch') || lowerCategory.includes('canapé')) {
    return FaCouch;
  }
  if (lowerCategory.includes('door') || lowerCategory.includes('porte')) {
    return (props) => <DoorOpenIcon {...props}/>;
  }
  if (lowerCategory.includes('handle') || lowerCategory.includes('poignee')) {
    return (props) => <ArchiveIcon {...props}/>;
  }
  if (lowerCategory.includes('facade')){
    return (props) => <DoorOpenIcon {...props}/>;
  }
  if (lowerCategory.includes('camera')){
    return FaCamera;
  }
  
  // Default icon
  return FaHome;
};

/**
 * Individual category item component
 * Displays category name with icon and handles selection
 */
const CategoryItem: React.FC<CategoryItemProps> = ({
  category,
  selected,
  onClick,
  icon,
}) => {
  const CategoryIcon = icon || getCategoryIcon(category);

  return (
    <ItemContainer selected={selected} onClick={onClick}>
      <IconWrapper selected={selected}>
        <CategoryIcon size={20} />
      </IconWrapper>
      <CategoryName>{category.toLowerCase()}</CategoryName>
      {selected && <SelectionIndicator />}
    </ItemContainer>
  );
};

const ItemContainer = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: ${({ selected }) => (selected ? '#C37427' : '#fff')};
  color: ${({selected}) => (selected ? "white" : "black")};
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 18px;
  text-transform: capitalize;
  &:hover {
    // background-color: ${({ selected }) => (selected ? '#5a8c3a' : '#3a6020')};
  }

  &:active {
    transform: scale(0.98);
  }
`;

const IconWrapper = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 6px;
  // background-color: ${({ selected }) => (selected ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)')};
  transition: all 0.2s ease;
`;

const CategoryName = styled.span`
  flex: 1;
  font-size: 1rem;
  font-weight: 500;
  text-transform: capitalize;
  letter-spacing: 0.02em;
`;

const SelectionIndicator = styled.div`
  position: absolute;
  right: 1rem;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
`;

export default CategoryItem;
